var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import CaseMarker from "~/components/common/case-marker.vue";
import { Getter, Mutation, State, namespace } from "vuex-class";
import { CaseInfoService } from "~/services/domain-service/case-info.service";
import { VisitCaseManageService } from "~/services/domain-service/visit-case-manage.service";
import { CaseApplyRecordService } from "~/services/domain-service/case-apply-record.service";
import CaseAllot from "~/components/distribution-common/case-allot.vue";
import { ApplyType, CASE_CHANNEL, CASE_HALT_CATEGORY, MENU_CHANNEL } from "~/config/enum.config";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
import TeamCaseRepayment from "~/components/visit-case/team-case-repayment.vue";
import TeamCaseBatchRepayment from "~/components/visit-case/team-case-batch-repayment.vue";
import TurnSourceApply from "~/components/apply-component/turn-source-apply.vue";
import PauseApply from "~/components/apply-component/pause-apply.vue";
import LeaveCaseApply from "~/components/apply-component/leave-case-apply.vue";
import SelectDepartment from "~/components/business-component/select-department.vue";
var AllotModule = namespace("case-allot");
var VisitTeamCaseManage = /** @class */ (function (_super) {
    __extends(VisitTeamCaseManage, _super);
    function VisitTeamCaseManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            overdueAmount: {
                max: "",
                min: ""
            },
            loanDate: [],
            principalId: '',
            partCollectionRemainingDays: { min: '', max: '' },
            personalCollectionRemainingDays: { min: '', max: '' },
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            dataFromSource: '',
            followInTime: [],
            deptId: '',
            currentCollectorRealName: '',
            partnerName: '',
            batchNumber: '',
            caseMark: ''
        };
        _this.dialog = {
            ManualDivision: false,
            apply: false,
            repayment: false,
            batchRepayment: false,
            applyDialog: false
        };
        _this.rules = {};
        _this.dataSet = [];
        _this.selectionList = [];
        _this.caseMark = "";
        _this.applyFlowCase = {};
        _this.applyType = {};
        _this.caseChannel = CASE_CHANNEL.visit;
        _this.otherModel = {
            caseHaltCategory: CASE_HALT_CATEGORY.CASE_HALT
        };
        _this.totalInfo = {};
        _this.teamCaseObj = {};
        _this.selectCaseList = [];
        _this.isComponent = '';
        _this.applyComponent = [
            {
                name: '申请流转',
                component: 'turn-source-apply',
                applyType: ApplyType.turn,
                auth: 612
            },
            {
                name: '申请停催',
                component: 'pause-apply',
                applyType: ApplyType.pause,
                auth: 613
            },
            {
                name: '申请留案',
                component: 'leave-case-apply',
                applyType: ApplyType.leave,
                auth: 614
            },
        ];
        return _this;
    }
    VisitTeamCaseManage.prototype.mounted = function () {
        this.refreshData();
    };
    VisitTeamCaseManage.prototype.activated = function () {
        this.refreshData();
    };
    VisitTeamCaseManage.prototype.departemntChange = function (id, code) { };
    VisitTeamCaseManage.prototype.queryTotalInfo = function () {
        var _this = this;
        this.visitCaseManageService
            .visitTeamCasePoolAmount(this.paramsHandler())
            .subscribe(function (data) { return (_this.totalInfo = data); });
    };
    VisitTeamCaseManage.prototype.queryPageInfo = function () {
        var _this = this;
        this.visitCaseManageService
            .visitTeamCasePool(this.paramsHandler(), this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    /**
     * 查询案件
     */
    VisitTeamCaseManage.prototype.refreshData = function () {
        this.queryTotalInfo();
        this.queryPageInfo();
    };
    VisitTeamCaseManage.prototype.paramsHandler = function () {
        var params = __assign({}, this.model);
        params.overdueAmountMax = this.model.overdueAmount ? this.model.overdueAmount.max : "";
        params.overdueAmountMin = this.model.overdueAmount ? this.model.overdueAmount.min : "";
        params.partCollectionRemainingDaysMax = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.max : "";
        params.partCollectionRemainingDaysMin = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.min : "";
        params.personalCollectionRemainingDaysMax = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.max : "";
        params.personalCollectionRemainingDaysMin = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.min : "";
        params.followInTimeMin = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[0]) : '';
        params.followInTimeMax = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[1]) : '';
        params.loanDateMin = this.$filter.dateRanageFormat(this.model.loanDate).start;
        params.loanDateMax = this.$filter.dateRanageFormat(this.model.loanDate).end;
        delete params.overdueAmount;
        delete params.partCollectionRemainingDays;
        delete params.personalCollectionRemainingDays;
        delete params.followInTime;
        delete params.loanDate;
        return params;
    };
    /**
     * 进入查看执行页
     */
    VisitTeamCaseManage.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Visit_team,
            otherData: {
                data: this.model,
                page: this.pageService,
                sort: this.sortService
            }
        });
    };
    /**
     * 重置dataRange
     */
    VisitTeamCaseManage.prototype.follFeedback = function () {
        this.model.overdueAmount = { min: "", max: "" };
        this.model.partCollectionRemainingDays = { min: '', max: '' };
        this.model.personalCollectionRemainingDays = { min: '', max: "" };
    };
    /**
     * 手动分案
     */
    VisitTeamCaseManage.prototype.manualDivision = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要分配的案件");
            return;
        }
        this.updateCaseIds(this.selectionList.map(function (v) { return v.id; }));
        this.dialog.ManualDivision = true;
    };
    /**
     * 申请
     */
    VisitTeamCaseManage.prototype.applyClick = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.applyType = item.applyType;
                if (this.selectionList.length === 0) {
                    this.$message("\u8BF7\u9009\u62E9\u8981" + this.applyType.name + "\u7684\u6848\u4EF6");
                    return [2 /*return*/];
                }
                this.isComponent = item.component;
                this.dialog.applyDialog = true;
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(VisitTeamCaseManage.prototype, "selectedCaseIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.id; });
        },
        enumerable: false,
        configurable: true
    });
    VisitTeamCaseManage.prototype.onColorChange = function (val) {
        var colorModel = {
            caseIds: this.selectionList.map(function (v) { return v.id; }),
            caseMark: val
        };
        this.caseInfoService
            .caseInfoMarkColor(colorModel)
            .subscribe(this.refreshData);
    };
    VisitTeamCaseManage.prototype.onApplyClose = function () {
        this.dialog.apply = false;
        // 重置其他数据
        this.otherModel = {};
        this.refreshData();
    };
    /**
     * 还款
     */
    VisitTeamCaseManage.prototype.repaymentClick = function (row) {
        this.dialog.repayment = true;
        this.teamCaseObj = row;
    };
    /**
     * 批量还款
     */
    VisitTeamCaseManage.prototype.batchRepaymentClick = function () {
        if (this.selectionList.length !== 0) {
            this.dialog.batchRepayment = true;
            this.selectCaseList = this.selectionList;
        }
        else {
            this.$message("\u8BF7\u9009\u62E9\u8981\u6279\u91CF\u8FD8\u6B3E\u7684\u6848\u4EF6");
        }
    };
    /**
     * 批量还款弹窗关闭回调
     */
    VisitTeamCaseManage.prototype.dialogClose = function () {
        this.refreshData();
        this.dialog.batchRepayment = false;
        this.selectionList = [];
    };
    __decorate([
        Dependencies(PageService)
    ], VisitTeamCaseManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], VisitTeamCaseManage.prototype, "sortService", void 0);
    __decorate([
        Dependencies(VisitCaseManageService)
    ], VisitTeamCaseManage.prototype, "visitCaseManageService", void 0);
    __decorate([
        Dependencies(CaseApplyRecordService)
    ], VisitTeamCaseManage.prototype, "CaseApplyRecordService", void 0);
    __decorate([
        Dependencies(CaseInfoService)
    ], VisitTeamCaseManage.prototype, "caseInfoService", void 0);
    __decorate([
        Mutation
    ], VisitTeamCaseManage.prototype, "updateCollectionType", void 0);
    __decorate([
        Getter
    ], VisitTeamCaseManage.prototype, "visitDepartmentData", void 0);
    __decorate([
        AllotModule.Mutation
    ], VisitTeamCaseManage.prototype, "updateCaseIds", void 0);
    __decorate([
        State
    ], VisitTeamCaseManage.prototype, "principalList", void 0);
    VisitTeamCaseManage = __decorate([
        Auth(603),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                NumberRange: NumberRange,
                CaseMarker: CaseMarker,
                CaseAllot: CaseAllot,
                TeamCaseRepayment: TeamCaseRepayment,
                TeamCaseBatchRepayment: TeamCaseBatchRepayment,
                TurnSourceApply: TurnSourceApply,
                PauseApply: PauseApply,
                LeaveCaseApply: LeaveCaseApply,
                SelectDepartment: SelectDepartment
            }
        })
    ], VisitTeamCaseManage);
    return VisitTeamCaseManage;
}(Vue));
export default VisitTeamCaseManage;
